<template>
  <tr>
    <td>
      <div class="d-flex">
        <v-btn
          v-if="item.edit === false"
          text
          tile
          @click="toggleEdit(item)"
        >
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          v-if="item.edit === true"
          text
          tile
          @click="toggleEdit(item)"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>
        <v-btn
          v-if="item.new"
          text
          tile
          @click="items.splice(items.indexOf(item), 1)"
        >
          <v-icon small>delete</v-icon>
        </v-btn>
      </div>
    </td>
    <td>
      <select-project
        v-if="item.new || item.edit"
        v-model="item.entity_id"
        :project-list-custom="projectList"
        :multiple="true"
        single-line
        class="pt-0 mt-0"
        @change="changeHandler($event, item, 'entity_id')"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      ></select-project>
      <span v-else>
        {{ projectListDisplay }}
      </span>
    </td>
    <td>
      <template v-if="item.new || item.edit">
        <v-combobox
          v-model="item.paymethod_name"
          :items="paymethods"
          :disabled="(!item.edit && !item.new) || item.paymethod_name.filter(o=> system_brand.map(o => o.value).includes(o)).length > 0"
          v-if="item.paymethod_name.filter(o=> system_brand.map(o => o.value).includes(o)).length === 0"
          placeholder="Payment Providers"
          hide-details
          auto-select-first
          multiple
          single-line
          class="pt-0 mt-0"
          :return-object="false"
          :style="{'white-space': 'nowrap', 'display': 'block', 'font-size': '14px'}"
        >
          <template v-slot:selection="{ item }">
              <span class="comma-sep" v-if="paymethods.includes(item.text || item)">
                {{ item.text || item }}
              </span>
          </template>
        </v-combobox>
        <v-combobox
          v-model="item.paymethod_name"
          :items="system_brand"
          :disabled="(!item.edit && !item.new) || item.paymethod_name.filter(o=> paymethods.includes(o)).length > 0"
          v-if="item.paymethod_name.filter(o=> paymethods.includes(o)).length === 0"
          placeholder="Game Brands"
          hide-details
          auto-select-first
          multiple
          single-line
          class="pt-0 mt-0"
          :return-object="false"
          :style="{'white-space': 'nowrap', 'display': 'block', 'font-size': '14px'}"
        >

          <template v-slot:selection="{ item }">
              <span class="comma-sep" v-if="system_brand.map(o => o.value).includes(item)">
                {{ item }}
              </span>
          </template>
        </v-combobox>
      </template>
      <template v-else>
        {{ item.paymethod_name.join(', ') }}
      </template>
    </td>
    <td>
      <v-combobox
        v-if="item.new || item.edit"
        v-model="item.country"
        :items="countries"
        hide-details
        multiple
        auto-select-first
        single-line
        item-value="code"
        item-text="code"
        class="pt-0 mt-0"
        :return-object="false"
        @change="changeHandler($event, item, 'country')"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      />
      <span v-else>{{ item.country.join(', ') }}</span>
    </td>
    <td>
      <v-select
        v-if="item.new || item.edit"
        v-model="item.currency"
        :items="currencies"
        hide-details
        multiple
        single-line
        class="pt-0 mt-0"
        @change="changeHandler($event, item, 'currency')"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      />
      <span v-else>{{ item.currency.join(', ') }}</span>
    </td>
    <td>
      <v-select
        v-if="item.new || item.edit"
        v-model="item.type"
        :items="['external', 'internal']"
        hide-details
        single-line
        class="pt-0 mt-0"
        :return-object="false"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      />
      <span v-else>{{ item.type }}</span>
    </td>
    <td>
      <v-text-field
        v-if="item.new || item.edit"
        v-model="item.settings.ggr.fee_rate"
        hide-details
        suffix="%"
        class="pt-0 mt-0"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      />
      <span v-else>{{ item.settings.ggr.fee_rate || '_' }}%</span>
    </td>
    <td>
      <v-text-field
        v-if="item.new || item.edit"
        v-model="item.settings.hold"
        hide-details
        class="pt-0 mt-0"
        suffix="%"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      />
      <span v-else>{{ item.settings.hold || '_' }}%</span>
    </td>
    <td>
      <v-text-field
        v-if="item.new || item.edit"
        v-model="item.settings.deposit.fee_rate"
        hide-details
        class="pt-0 mt-0"
        suffix="%"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      />
      <span v-else>{{ item.settings.deposit.fee_rate || '_' }}%</span>
    </td>

    <td>
      <v-select
        v-if="item.new || item.edit"
        v-model="item.settings.deposit.currency"
        :items="$store.state.auth.currencies"
        hide-details
        clearable
        single-line
        class="pt-0 mt-0"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      />
      <span v-else>{{ item.settings.deposit.currency }}</span>
    </td>

    <td>
      <v-text-field
        v-if="item.new || item.edit"
        v-model="item.settings.deposit.per_transaction"
        hide-details
        class="pt-0 mt-0"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      />
      <span v-else>{{ item.settings.deposit.per_transaction }}</span>
    </td>

    <td>
      <v-text-field
        v-if="item.new || item.edit"
        v-model="item.settings.withdraw.fee_rate"
        hide-details
        class="pt-0 mt-0"
        suffix="%"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      />
      <span v-else>{{ item.settings.withdraw.fee_rate || '_' }}%</span>
    </td>

    <td>
      <v-select
        v-if="item.new || item.edit"
        v-model="item.settings.withdraw.currency"
        :items="$store.state.auth.currencies"
        hide-details
        clearable
        single-line
        class="pt-0 mt-0"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      />
      <span v-else>{{ item.settings.withdraw.currency }}</span>
    </td>

    <td>
      <v-text-field
        v-if="item.new || item.edit"
        v-model="item.settings.withdraw.per_transaction"
        hide-details
        class="pt-0 mt-0"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      />
      <span v-else>{{ item.settings.withdraw.per_transaction }}</span>
    </td>

    <td>
      <v-text-field
        v-if="item.new || item.edit"
        v-model="item.settings.chargeback.fee_rate"
        hide-details
        class="pt-0 mt-0"
        suffix="%"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      />
      <span v-else>{{ item.settings.chargeback.fee_rate || '_' }}%</span>
    </td>

    <td>
      <v-select
        v-if="item.new || item.edit"
        v-model="item.settings.chargeback.currency"
        :items="$store.state.auth.currencies"
        hide-details
        clearable
        single-line
        class="pt-0 mt-0"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      />
      <span v-else>{{ item.settings.chargeback.currency }}</span>
    </td>

    <td>
      <v-text-field
        v-if="item.new || item.edit"
        v-model="item.settings.chargeback.per_transaction"
        hide-details
        class="pt-0 mt-0"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      />
      <span v-else>{{ item.settings.chargeback.per_transaction }}</span>
    </td>

    <td>
      <v-text-field
        v-if="item.new || item.edit"
        v-model="item.settings.refund.fee_rate"
        hide-details
        class="pt-0 mt-0"
        suffix="%"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      />
      <span v-else>{{ item.settings.refund.fee_rate || '_' }}%</span>
    </td>

    <td>
      <v-select
        v-if="item.new || item.edit"
        v-model="item.settings.refund.currency"
        :items="$store.state.auth.currencies"
        hide-details
        clearable
        single-line
        class="pt-0 mt-0"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      />
      <span v-else>{{ item.settings.refund.currency }}</span>
    </td>

    <td>
      <v-text-field
        v-if="item.new || item.edit"
        v-model="item.settings.refund.per_transaction"
        hide-details
        class="pt-0 mt-0"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      />
      <span v-else>{{ item.settings.refund.per_transaction }}</span>
    </td>

    <td>
      <v-text-field
        v-if="item.new || item.edit"
        v-model="item.settings.settlement_fee"
        hide-details
        class="pt-0 mt-0"
        :style="{'white-space': 'nowrap', 'display': 'inline-block', 'font-size': '14px'}"
      />
      <span v-else>{{ item.settings.settlement_fee || '_' }}%</span>
    </td>
  </tr>
</template>
<script>
  import { cloneDeep, concat, map } from 'lodash'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {
    components: { SelectProject },
    props: {
      item: {
        type: Object,
        require: true
      },
      items: {
        type: Array,
        require: true
      },
      paymethods: {
        type: Array,
        require: true
      },
      gameBrand: {
        type: Array,
        require: true
      },
      system_brand: {
        type: Array,
        require: true
      },
      projectsById: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      countries () {
        return concat([ { 'code': 'Any', 'title': 'Any' } ], this.$store.state.app.countries)
      },
      currencies () {
        return concat([ 'Any' ], this.$store.state.auth.currencies)
      },
      projectList: function () {
        return map(concat([ { name: 'Any', entity_id: '*' } ], this.$store.state.auth.entities), (i) => ({ text: i.name, value: i.entity_id, licence: i.licence }))
      },
      projectListDisplay () {
        return this.item.entity_id[0] === '*' ? 'All' : this.item.entity_id.map(entityId => this.projectsById[entityId]?.name || entityId).join(', ')
      }
    },
    methods: {
      toggleEdit (item) {
        if (!item.edit) {
          item.init = cloneDeep(item)
          item.edit = true
        } else {
          for (let k in item.init) {
            item[k] = item.init[k]
          }
        }
      },
      changeHandler (value, item, field) {

        if (value.length == 0 || (value.length > 1 && (value.includes('*') && value[value.length - 1] == '*'))) {
          value = [ '*' ]
        } else if (value.length > 1 && value.includes('*') && value[value.length - 1] !== '*') {
          value.splice(value.indexOf('*'), 1)
        }

        if (value.length == 0 || (value.length > 1 && (value.includes('Any') && value[value.length - 1] == 'Any'))) {
          value = [ 'Any' ]
        } else if (value.length > 1 && value.includes('Any') && value[value.length - 1] !== 'Any') {
          value.splice(value.indexOf('Any'), 1)
        }

        item[field] = value
      },
    }
  }
</script>

<style scoped>

</style>
